module.exports = "<pdmi-content></pdmi-content>\n\n"


//////////////////
// WEBPACK FOOTER
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main